import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import '../styles/PurchaseCard.css';

const PurchaseCard = ({ purchase }) => {
  const {
    id,
    listing_title,
    listing_description,
    listing_price,
    listing_location,
    listing_image,
    price_offer,
    delivery_method,
    date_available,
    created_at,
    seller_name
  } = purchase;

  // Format price to 2 decimal places
  const formattedListingPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(listing_price);

  const formattedOfferPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(price_offer);

  // Format dates
  const formattedAvailableDate = new Date(date_available).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });

  const formattedCreatedDate = new Date(created_at).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });

  return (
    <div className="purchase-card">
      <div className="purchase-image">
        {listing_image ? (
          <img
            src={"https://local-api.stratfordtreasurehunt.com" + listing_image}
            alt={listing_title}
          />
        ) : (
          <div className="no-image">No Image</div>
        )}
      </div>
      <div className="purchase-content">
        <h3>{listing_title}</h3>
        <p className="listing-price">Original Price: {formattedListingPrice}</p>
        <p className="offer-price">Your Offer: {formattedOfferPrice}</p>
        <p className="description">{listing_description}</p>
        
        <div className="purchase-details">
          <div className="detail-row">
            <span className="label">Seller:</span>
            <span className="value">{seller_name}</span>
          </div>
          <div className="detail-row">
            <span className="label">Location:</span>
            <span className="value">{listing_location}</span>
          </div>
          <div className="detail-row">
            <span className="label">Delivery:</span>
            <span className="value">{delivery_method}</span>
          </div>
          <div className="detail-row">
            <span className="label">Available:</span>
            <span className="value">{formattedAvailableDate}</span>
          </div>
          <div className="detail-row">
            <span className="label">Accepted:</span>
            <span className="value">{formattedCreatedDate}</span>
          </div>
        </div>

        <div className="purchase-actions">
          <Link
            to={`/listings/${id}`}
            className="view-listing-btn"
          >
            View Listing
          </Link>
        </div>
      </div>
    </div>
  );
};

PurchaseCard.propTypes = {
  purchase: PropTypes.shape({
    id: PropTypes.number.isRequired,
    listing_title: PropTypes.string.isRequired,
    listing_description: PropTypes.string.isRequired,
    listing_price: PropTypes.number.isRequired,
    listing_location: PropTypes.string.isRequired,
    listing_image: PropTypes.string,
    price_offer: PropTypes.number.isRequired,
    delivery_method: PropTypes.string.isRequired,
    date_available: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    seller_name: PropTypes.string.isRequired
  }).isRequired
};

export default PurchaseCard; 